import AdminRequest from './AdminRequest';

/**
 * Provides client for API: /updates
 */
export default class UpdatesClient extends AdminRequest {
	constructor() {
		super('/updates');
	}

	get() {
		return this._op('get', this.uri);
	}
}
